import { Spin, Button, Affix } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import { isEmpty, isNull } from 'lodash';
import moment from 'moment';
import { getDeclarationNoticeDetail } from '@/services/largeGrainGrower';
import { getToken } from '@/utils/token';
import './index.less';
import FileDownload from '@/components/FileDownload/FileDownload';

export default function Detail() {
  const { search } = useLocation();
  const Navigate = useNavigate();

  const { status } = useSelector((state) => state);

  const { data, loading } = useRequest(() => getDeclarationNoticeDetail(qs.parse(search).id));

  function handleChange(item) {
    const token = getToken();
    if (!token) {
      Navigate('/login');
    } else if (status) {
      Navigate('/authentication');
    } else {
      const { id } = item;
      Navigate(`/largeGrainGrower/application?id=${id}`, { state: item });
    }
  }

  return (
    <div className="zczx-detail">
      <Spin spinning={loading}>
        <div className="content-width">
          <div className="zczx-detail__title">{data?.title}</div>
          <div>
            &emsp;&emsp;发布时间：
            {data?.gmtCreate}
          </div>
          <div className="zczx-detail__con">
            <div dangerouslySetInnerHTML={{ __html: data?.content }} />
          </div>
          {!isEmpty(data?.largeGrainGrowerFileVos) && (
            <div className="zczx-detail_appendix">
              <div style={{ lineHeight: '32px' }}>附件：</div>
              <div>
                {data?.largeGrainGrowerFileVos.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/grain/grower/download"
                  />
                ))}
              </div>
            </div>
          )}
          <Affix style={{ marginTop: 20 }} offsetBottom={0}>
            <div style={{ backgroundColor: 'white' }}>
              {
                (isNull(data?.filingDeadline) || (moment().diff(moment(data?.filingDeadline), 'days') <= 0)) && (
                  <Button style={{ margin: 10 }} type="primary" onClick={() => handleChange(data)}>
                    填写申报材料
                  </Button>
                )
              }
              <div className="zczx-detail_bottom-text">
                申报截止日期：
                {isNull(data?.filingDeadline) ? '-' : data?.filingDeadline}
              </div>
            </div>
          </Affix>
        </div>
      </Spin>
    </div>
  );
}
